import {
  Card, Box, Button, Typography,
} from '@mui/material';
import { useHomeContext } from '../context';

const LinkCard = ():JSX.Element => {
  const { currentLink } = useHomeContext();

  return (
    <Card>
      <Box padding={3} color="#666666">
        <Typography fontWeight={600}>
          Link para indicação
        </Typography>
        <Typography variant="body2" marginTop={1} sx={{ overflowWrap: 'anywhere', overflow: 'hidden' }}>
          {currentLink}
        </Typography>
        <Box display="flex" justifyContent="flex-end" marginTop={2}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={() => navigator.clipboard.writeText(currentLink)}
          >
            Copiar Código
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default LinkCard;
